(function () {
  'use strict';

  if (window.__ldCartDrawerRemoveInit) return;
  window.__ldCartDrawerRemoveInit = true;

  async function changeLine(key, quantity) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!r.ok) {
      let payload = null;
      try { payload = await r.json(); } catch (e) {}
      const msg = payload?.description || payload?.message || payload?.errors || ('Request failed: ' + r.status);
      throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
    }
    return r.json();
  }

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
    if (!r.ok) throw new Error('Failed to load cart: ' + r.status);
    return r.json();
  }

  function notifyCartUpdated() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  }

  function parseRelatedIds(linkEl) {
    const raw = linkEl?.dataset?.removeRelated || '';
    if (!raw) return [];
    return raw
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
      .map(n => parseInt(n, 10))
      .filter(n => Number.isFinite(n) && n > 0);
  }

  async function removeRelatedByProductIds(productIds) {
    if (!productIds.length) return;

    const cart = await getCart();
    const keysToRemove = (cart.items || [])
      .filter(it => productIds.includes(Number(it.product_id)))
      .map(it => it.key);

    for (const k of keysToRemove) {
      await changeLine(k, 0);
    }
  }

  document.addEventListener('click', async (e) => {
    const link = e.target.closest('.cart__remove a');
    if (!link) return;

    // nur im Drawer feuern
    if (!link.closest('#CartDrawer')) return;

    const href = link.getAttribute('href') || '';
    if (!href.includes('quantity=0') || !href.includes('id=')) return;

    e.preventDefault();
    e.stopPropagation();

    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');

    try {
      const relatedProductIds = parseRelatedIds(link);

      const url = new URL(href, window.location.origin);
      const key = url.searchParams.get('id');
      if (!key) throw new Error('Missing cart line key');

      await changeLine(key, 0);

      if (relatedProductIds.length) {
        await removeRelatedByProductIds(relatedProductIds);
      }

      notifyCartUpdated();
    } catch (err) {
      console.error('[ld-cart-drawer-remove]', err);
      alert('Remove failed: ' + (err?.message || err));
    } finally {
      link.removeAttribute('aria-busy');
    }
  }, true);
})();